import create from 'zustand'
import { persist } from "zustand/middleware"

const persistConfig = {
  name: "register-with-facebook-callback"
};

const registerWithFacebookCallbackStore = create(persist((set, get) => {

  const setSuccessPathAction = async (successPath) => {
    set({ successPath })
  }

  const setDataAction = async (facebookId, accessToken, email, firstname, lastname) => {
    const data = {
      facebookId, accessToken, email, firstname, lastname
    }
    set({ data })
  }

  const clearAllAction = () => set({
    ...initState
  })

  const initState = {
    successPath: null,
    data: null,
  }
  
  return {
    ...initState,
    setSuccessPath: setSuccessPathAction,
    setData: setDataAction,
    clearAll: clearAllAction,
  }
}, persistConfig));

export default registerWithFacebookCallbackStore;